export const DEFAULT_ANIMATION_TIME = 250;
export const AirlineCompanyName = 'Aeroitalia';
export const AirlineCompanyNameAsIdentifier = 'Aeroitalia';

